<template>
  <div class="reward-pass-wrapper">
    <h4 class="reward-title">Il tuo percorso</h4>
    <div class="coin-balance">
      Coin acquistati:
      <span class="coin">{{ userCredits || 0 }}</span>
    </div>
    <div class="reward-scroll-container">
      <div class="reward-path">
        <div
          v-for="(tier, index) in tiers"
          :key="index"
          class="reward-node"
          :class="{ unlocked: userCredits >= tier.soglia }"
        >
          <div class="reward-tier-circle">
            <span v-if="userCredits >= tier.soglia">✔</span>
            <span v-else>🔒</span>
          </div>
          <div class="reward-tier-info">
            <div class="tier-icon">{{ tier.icon }}</div>
            <div class="tier-feature">{{ tier.feature }}</div>
            <div class="tier-cost">{{ tier.soglia }} coin</div>
          </div>
        </div>
        <div class="progress-line-background">
          <div
            class="progress-line-foreground"
            :style="{ width: progressPercent + '%' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RewardPass",
  props: {
    userCredits: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tiers() {
      return [
        { soglia: 0, icon: "🎨", feature: "Tema Base" },
        { soglia: 100, icon: "🌙", feature: "Tema Scuro" },
        { soglia: 300, icon: "📸", feature: "Sfondo Personalizzato" },
        { soglia: 600, icon: "✨", feature: "Animazioni Icone" },
        { soglia: 1000, icon: "🌌", feature: "Tema Galaxy" },
        { soglia: 1500, icon: "🚀", feature: "Accesso Prioritario" },
        { soglia: 2000, icon: "👑", feature: "Badge Elite" },
      ];
    },
    maxTier() {
      return this.tiers[this.tiers.length - 1].soglia;
    },
    progressPercent() {
      return Math.min((this.userCredits / this.maxTier) * 100, 100);
    },
  },
};
</script>

<style scoped>
.reward-pass-wrapper {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  padding: 2rem;
  font-family: "Inter", "Segoe UI", sans-serif;
  margin: 2rem auto;
  max-width: 1200px;
}

.reward-title {
  text-align: center;
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 2rem;
}

.reward-scroll-container {
  overflow-x: auto;
  padding-bottom: 1rem;
}

.reward-path {
  display: flex;
  align-items: center;
  position: relative;
  gap: 3rem;
  padding: 1rem;
  min-width: max-content;
}

.reward-node {
  position: relative;
  text-align: center;
  width: 140px;
  flex: 0 0 auto;
  z-index: 2;
}

.reward-tier-circle {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  border-radius: 50%;
  border: 3px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  font-size: 1.5rem;
  transition: all 0.3s ease;
}

.reward-node.unlocked .reward-tier-circle {
  border-color: #4caf50;
  background: #e6f5ea;
  color: #2e7d32;
}

.reward-tier-info {
  margin-top: 0.6rem;
}

.tier-icon {
  font-size: 1.3rem;
  margin-bottom: 0.2rem;
}

.tier-feature {
  font-weight: 600;
  font-size: 0.9rem;
  color: #444;
}

.tier-cost {
  font-size: 0.75rem;
  color: #888;
}

.progress-line-background {
  position: absolute;
  top: 30px;
  left: 30px;
  right: 30px;
  height: 4px;
  background-color: #d3d3d3;
  z-index: 1;
  border-radius: 2px;
}

.progress-line-foreground {
  height: 100%;
  background: linear-gradient(to right, #4caf50, #8bc34a);
  border-radius: 2px;
  transition: width 0.5s ease;
}
</style>
